export default "__VITE_ASSET__94126633__"